/**
 * Represents an entity to compare to the current fiscal year.
 */
export default class AbstractBusinessTrendComparisonElement {
	getId() {
		throw new Error("Subclass responsibility");
	}

	getName() {
		throw new Error("Subclass responsibility");
	}

	getNameRenderer({ router: _router }) {
		return this.getName();
	}

	getPeriodNameRenderer({ period, router: _router }) {
		return period.toSmartString();
	}

	getGroupName() {
		throw new Error("Subclass responsibility");
	}

	findPeriodMatching(period) {
		return this._getFiscalYear().findPeriod(
			period.getPeriodType(),
			period.getPeriodIndex(),
		);
	}

	fetchAnnualTrend(_fetcher) {
		throw new Error("Subclass responsibility");
	}

	_getFiscalYear() {
		throw new Error("Subclass responsibility");
	}
}
